export const REQUIRED_FIELD = "Ce champ est requis";
export const ACTIVITY_REGISTRATION_NUMBER_ERROR_MESSAGE = "Le numéro de déclaration d'activité doit contenir 11 chiffres";
